import React, {useCallback, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  langsMap,
} from '@goaffpro/aff-client-commons/translations/localehandler';
import Dropdown from './Dropdown';
import {getItem, setItem} from '../../tools/storage';

function LangsSelector(props){
    const [locale, setLocale] = useState(props.locale)
    useEffect(()=>{
        setLocale(props.locale)
    },[props.locale])
    const  onChange = useCallback((value) => {
        setLocale(value)
        setItem('locale', value);
        document.location.reload();
    },[])

        const items = Object.keys(langsMap).map((key) => {
            return {value: key, label: langsMap[key]}
        })
        return (<>
                <Dropdown onSelected={onChange} direction={"up"} opts={items} selected={locale} />
            </>
        );
}

function mapStateToProps(state) {
    return {
        locale: getItem("locale") || state.settings.locale
    }
}


export default connect(mapStateToProps)(LangsSelector);
